import React, { useState, useEffect } from "react";
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Layout from "./Layout";
import { makeStyles } from "@material-ui/core/styles";
import classNames from "classnames";

// sections of this Page
import Button from "components/CustomButtons/Button.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Loading from "components/Common/loading";
import CardHeader from "components/Card/CardHeader.js";
import Check from "@material-ui/icons/Check";
import headersStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.js";

import basicsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.js";
import customerDetailsStyles from "assets/jss/material-kit-pro-react/views/cspDashboard/customerDetailsStyles.js";
import Checkbox from "@material-ui/core/Checkbox";

import get, { post } from "../../lib/requests";
import {
	LoadingMgs,
	SuccessMessage,
	ErrorMessage,
} from "components/Common/toastify";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";

const useStyles2 = makeStyles(headersStyle);
const useStyles3 = makeStyles(basicsStyle);
const useStylesCustomerDetailsStyles = makeStyles(customerDetailsStyles);

export default function AddUserPage() {
	const classes2 = useStyles2();
	const { id } = useParams(); // Extracts the 'id' from the URL
	const classesCSStyles = useStylesCustomerDetailsStyles();
	const classes = useStyles3();
	const [loading, setLoading] = useState(false);
	const [readonly, setReadonly] = useState(false);
	const [viewaccounts, setViewAccounts] = useState(false);
	const [iscreator, setIsCreator] = useState(false);
	const [isAdmin, setIsAdmin] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		window.scrollTo(0, 0);
		document.body.scrollTop = 0;

		if (id) {
			getUserData(id);
		}
		return function cleanup() {};
	}, []);

	const getUserData = async (id) => {
		setLoading(true);
		try {
			await get(`/api/user/${id}`, true)
				.then((res) => {
					if (res.data.success) {
						console.log("res.data.records", res.data.records);
						setValue("firstname", res.data.records.fname);
						setValue("lastname", res.data.records.lname);
						setValue("email", res.data.records.email);
						setValue("phone", res.data.records.phone);
						setIsAdmin(res.data.records.isAdmin);
						setIsCreator(res.data.records.iscreator);
						setViewAccounts(res.data.records.viewaccounts);
						setReadonly(res.data.records.readonly);
					} else {
						ErrorMessage("User Details", res.data.message);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("User Details", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("User Details", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	// form validation rules
	const validationSchema = Yup.object().shape({
		firstname: Yup.string().required("First name is required"),
		lastname: Yup.string().required("Last name is required"),
		email: Yup.string().email("Email is invalid").required("Email is required"),

		phone: Yup.string()
			.required("Phone number is required")
			.matches(/^[0-9]{10}$/, "Phone number must be 10 digits"),

		readonly: Yup.boolean().oneOf(
			[true, false],
			"Read only must be true or false"
		),
		viewaccounts: Yup.boolean().oneOf(
			[true, false],
			"View accounts must be true or false"
		),
		iscreator: Yup.boolean().oneOf(
			[true, false],
			"Is creator must be true or false"
		),
		isAdmin: Yup.boolean().oneOf([true, false], "Is admin must be true or false"),
	});
	const formOptions = { resolver: yupResolver(validationSchema) };

	// get functions to build form with useForm() hook
	const {
		register,
		handleSubmit,
		setError,
		setValue,
		reset,
		formState,
	} = useForm(formOptions);
	const { errors } = formState;

	async function onSubmit(formField) {
		setLoading(true);
		LoadingMgs("Edit User", "processing...");

		try {
			formField.readonly = readonly ? "yes" : "no";
			formField.viewaccounts = viewaccounts ? "yes" : "no";
			formField.iscreator = iscreator ? "yes" : "no";
			formField.isAdmin = isAdmin ? "yes" : "no";

			await post(`/api/updateuser/${id}`, formField, true)
				.then((res) => {
					if (res.data.success) {
						SuccessMessage("Edit User", "User updated successfully");
						navigate("/users");
						reset();
					} else {
						ErrorMessage("Edit User", res.data.message);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Edit User", message);
					setLoading(false);
				});
		} catch (error) {
			console.log("error", error);
			ErrorMessage("Edit User", "Something went wrong try again!!");
			setLoading(false);
		}
	}

	return (
		<div>
			<Header
				color="info"
				brand="Auscomp Cloud Services"
				links={<HeaderLinks dropdownHoverColor="info" />}
				fixed
			/>
			<Layout>
				<br />
				<Card>
					<CardHeader color="info" className="">
						<GridContainer>
							<GridItem xs={12} sm={6} md={6}>
								<h4 className={classesCSStyles?.labelAc}>Edit User</h4>
							</GridItem>
						</GridContainer>
					</CardHeader>
					<CardBody
						className={classNames(
							classesCSStyles.accountSection,
							loading ? classesCSStyles.loading : ""
						)}>
						<form onSubmit={handleSubmit(onSubmit)}>
							<GridContainer>
								<GridItem xs={12} sm={4} md={4} className={classes2.customInput}>
									<div className={classNames(classes2.labelTitle)}>
										First name <span className="text-red-600 mr-2"> * </span>
									</div>
									<CustomInput
										inputProps={{
											placeholder: "Enter first name here",
											...register("firstname"),
										}}
										formControlProps={{
											fullWidth: true,
											className: classes2.formControl,
										}}
									/>
									<div className="text-red-600 text-xs ml-3 pt-1">
										{errors.firstname?.message}
									</div>
								</GridItem>
								<GridItem xs={12} sm={4} md={4} className={classes2.customInput}>
									<div className={classNames(classes2.labelTitle)}>
										Last name <span className="text-red-600 mr-2">* </span>
									</div>
									<CustomInput
										inputProps={{
											placeholder: "Enter last name here",
											...register("lastname"),
										}}
										formControlProps={{
											fullWidth: true,
											className: classes2.formControl,
										}}
									/>
									<div className="text-red-600 text-xs ml-3 pt-1">
										{errors.lastname?.message}
									</div>
								</GridItem>
								<GridItem xs={12} sm={4} md={4} className={classes2.customInput}>
									<div className={classNames(classes2.labelTitle)}>
										Email address <span className="text-red-600 mr-2">* </span>
									</div>
									<CustomInput
										inputProps={{
											placeholder: "Enter email address here",
											...register("email"),
										}}
										formControlProps={{
											fullWidth: true,
											className: classes2.formControl,
										}}
									/>
									<div className="text-red-600 text-xs ml-3 pt-1">
										{errors.email?.message}
									</div>
								</GridItem>
								<GridItem xs={12} sm={4} md={4} className={classes2.customInput}>
									<div className={classNames(classes2.labelTitle)}>
										Phone number <span className="text-red-600 mr-2">* </span>
									</div>
									<CustomInput
										inputProps={{
											placeholder: "Enter phone number here",
											...register("phone"),
										}}
										formControlProps={{
											fullWidth: true,
											className: classes2.formControl,
										}}
									/>
									<div className="text-red-600 text-xs ml-3 pt-1">
										{errors.phone?.message}
									</div>
								</GridItem>

								<GridItem xs={12} sm={12} md={12} className={classes2.customInput}>
									<div className={classNames(classes2.labelTitle, classesCSStyles?.py5)}>
										<h3>Access Rights</h3>
									</div>
									<div
										className={
											classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal
										}>
										<FormControlLabel
											control={
												<Checkbox
													tabIndex={-1}
													onClick={() => {
														setIsAdmin(!isAdmin);
													}}
													checked={isAdmin}
													checkedIcon={<Check className={classes.checkedIcon} />}
													icon={<Check className={classes.uncheckedIcon} />}
													classes={{
														checked: classes.checked,
														root: classes.checkRoot,
													}}
												/>
											}
											classes={{ label: classes.label, root: classes.labelRoot }}
											label="Administrator"
										/>
									</div>
									<div
										className={
											classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal
										}>
										<FormControlLabel
											control={
												<Checkbox
													tabIndex={-1}
													onClick={() => {
														setIsCreator(!iscreator);
													}}
													checked={iscreator}
													checkedIcon={<Check className={classes.checkedIcon} />}
													icon={<Check className={classes.uncheckedIcon} />}
													classes={{
														checked: classes.checked,
														root: classes.checkRoot,
													}}
												/>
											}
											classes={{ label: classes.label, root: classes.labelRoot }}
											label="License Admin"
										/>
									</div>
									<div
										className={
											classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal
										}>
										<FormControlLabel
											control={
												<Checkbox
													tabIndex={-1}
													onClick={() => {
														setViewAccounts(!viewaccounts);
													}}
													checked={viewaccounts}
													checkedIcon={<Check className={classes.checkedIcon} />}
													icon={<Check className={classes.uncheckedIcon} />}
													classes={{
														checked: classes.checked,
														root: classes.checkRoot,
													}}
												/>
											}
											classes={{ label: classes.label, root: classes.labelRoot }}
											label="Accounts"
										/>
									</div>
									<div
										className={
											classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal
										}>
										<FormControlLabel
											control={
												<Checkbox
													tabIndex={-1}
													onClick={() => {
														setReadonly(!readonly);
													}}
													checked={readonly}
													checkedIcon={<Check className={classes.checkedIcon} />}
													icon={<Check className={classes.uncheckedIcon} />}
													classes={{
														checked: classes.checked,
														root: classes.checkRoot,
													}}
												/>
											}
											classes={{ label: classes.label, root: classes.labelRoot }}
											label="Read Only"
										/>
									</div>
								</GridItem>
								<GridItem xs={12} sm={12} md={12}>
									<div className={classNames("flex", classesCSStyles?.alignRight)}>
										<button
											className={classNames(classesCSStyles.buttonPrimary)}
											type="submit"
											disabled={formState.isSubmitting}>
											Save
										</button>
										<Button
											size="sm"
											color="danger"
											onClick={() => {
												window.location.href = "/users";
											}}>
											Cancel
										</Button>
									</div>
								</GridItem>
							</GridContainer>
						</form>
					</CardBody>
				</Card>
			</Layout>
		</div>
	);
}
